import { isAddress } from 'viem';
import { ROBINHOOD_CHAIN_ID } from './chain.js';
const REQUIRED = [
    'factory',
    'arena',
    'router',
    'ledger',
    'locker',
    'graduator',
    'treasury',
    'multisig',
    'poolManager',
    'positionManager',
    'permit2',
];
export class DeploymentInvalid extends Error {
}
export function parseDeployment(raw) {
    if (typeof raw !== 'object' || raw === null)
        throw new DeploymentInvalid('deployment is not an object');
    const d = raw;
    for (const key of REQUIRED) {
        const v = d[key];
        if (typeof v !== 'string' || !isAddress(v))
            throw new DeploymentInvalid(`deployment.${key} is not an address`);
        if (/^0x0{40}$/i.test(v))
            throw new DeploymentInvalid(`deployment.${key} is the zero address`);
    }
    if (typeof d.chainId !== 'number')
        throw new DeploymentInvalid('deployment.chainId is missing');
    if (typeof d.startBlock !== 'number' || d.startBlock < 0) {
        throw new DeploymentInvalid('deployment.startBlock is missing: the indexer needs the factory deployment block');
    }
    const parsed = d;
    return { ...parsed, name: parsed.name || 'Robinhood Chain' };
}
export function deploymentPath(chainId = ROBINHOOD_CHAIN_ID) {
    return `deployments/${chainId}.json`;
}
//# sourceMappingURL=addresses.js.map